/**
 * Tells the applicant which credential their account is actually on.
 *
 * Web signup registers the account against the **phone number** they just
 * verified, but the app's sign-in screen offers "Continue with Google" and
 * "Continue with Apple" right below the phone field. Picking one with an
 * address that differs from the one on their application starts a second,
 * empty account — guaranteed when they choose Apple's "Hide My Email".
 *
 * Purely a positive instruction: it names the button to press and stops there.
 * An earlier draft carried a line cautioning against the social buttons, which
 * traded a small gain in prevention for doubt on a screen whose job is to feel
 * like an ending — and the app recovers from that path anyway.
 *
 * No hooks or server-only APIs, so this renders inside both the server-rendered
 * done page and the client-side verify form.
 */
export function SignInNote() {
  return (
    <div className="join-doc text-left" style={{ display: "block", padding: "16px 18px" }}>
      <p className="mb-1 text-[0.95rem] font-semibold">How to sign in</p>
      <p className="text-[0.92rem] leading-[1.55]" style={{ color: "var(--ink-2)" }}>
        Your account is registered to the phone number you just verified. Open the app, tap{" "}
        <strong style={{ color: "var(--ink)" }}>I already have an account</strong>, and enter that
        same number.
      </p>
    </div>
  );
}
